<script setup lang="ts">
const { bannerContent } = defineProps<{
  bannerContent: any
}>()

const { remaining, start } = useCountdown(shallowRef(0))
watchEffect(() => {
  const time = bannerContent?.DateTo ? new Date(bannerContent.DateTo).getTime() : null
  if (!time) {
    return
  }
  start((time - new Date().getTime()) / 1000)
})

const countdown = computed(() => {
  if (!remaining.value) {
    return ''
  }

  const totalSeconds = remaining.value
  const days = Math.floor(totalSeconds / (24 * 3600))
  const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = Math.floor(totalSeconds % 60)

  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  }
})

const bannerStyle = computed(() => {
  return {
    '--promo-color': bannerContent?.BackgroundColor || '#040404',
    '--contrast-color': useContrastColor((bannerContent?.BackgroundColor || '#040404'), 'var(--color-copy-reverse)', 'var(--color-copy-default)'),
  }
})
</script>

<template>
  <div :style="bannerStyle">
    <div class="promo-banner__item">
      <StrapiBlocksText
        v-if="bannerContent?.Text?.length"
        :nodes="bannerContent.Text"
      />

      <div
        v-if="remaining > 0 && bannerContent?.DateTo && bannerContent?.EnableCountdown"
        class="countdown"
      >
        <span
          v-if="countdown.days"
          class="countdown__section"
        >
          <span class="countdown__digit">{{ countdown.days }}</span>
          <span class="countdown__unit">d</span>
        </span>
        <span
          v-if="countdown.days || countdown.hours"
          class="countdown__section"
        >
          <span class="countdown__digit">{{ countdown.hours }}</span>
          <span class="countdown__unit">u</span>
        </span>
        <span
          v-if="countdown.days || countdown.hours || countdown.minutes"
          class="countdown__section"
        >
          <span class="countdown__digit">{{ countdown.minutes }}</span>
          <span class="countdown__unit">m</span>
        </span>
        <span class="countdown__section">
          <span class="countdown__digit">{{ countdown.seconds }}</span>
          <span class="countdown__unit">s</span>
        </span>
      </div>
    </div>
  </div>
</template>
